import { render, staticRenderFns } from "./ThemeRetriever.vue?vue&type=template&id=72530916&"
import script from "./ThemeRetriever.vue?vue&type=script&lang=ts&"
export * from "./ThemeRetriever.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports